module.exports = __webpack_public_path__ + "static/media/bac-pin.f52250ff.svg";